// extracted by mini-css-extract-plugin
export default {"submitBox":"src-assets-style-scss-___submission-box__submitBox___UwWPm"};